import axios, { AxiosError, AxiosInstance } from 'axios';
import { lireJeton, terminerSessionExpiree } from '../auth/session';

export const userApi = axios.create({ baseURL: 'https://dev-user.tribe.sn', withCredentials: true });
export const locationApi = axios.create({ baseURL: 'https://dev-location.tribe.sn', withCredentials: true });
/* admin-service : documents de facturation émis au client (devis, contrats, factures, avoirs).
   Sans cookies : le jeton part en en-tête, et admin-service n'autorise pas les requêtes
   avec identifiants (pas d'Access-Control-Allow-Credentials). */
export const adminApi = axios.create({ baseURL: 'https://dev-admin.tribe.sn' });

/* Le cookie clientToken est host-only sur dev-user.tribe.sn : il n'est jamais transmis à
   dev-location.tribe.sn. On rejoue donc le JWT renvoyé au login en en-tête Authorization. */
export const getClientToken = lireJeton;

/* Routes publiques de user-service : un 401 y est une réponse métier (mauvais mot
   de passe), pas une fin de session. */
const ROUTES_SANS_SESSION = ['/user/client-login', '/user/client-register', '/user/client-verify',
  '/user/client-invitation', '/user/forgot-password', '/user/change-password'];

const poserJeton = (api: AxiosInstance) => {
  api.interceptors.request.use((config) => {
    const token = lireJeton();
    if (token) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
};

/* 401 d'un service sur une route qui exige la session : jeton expiré ou refusé.
   Le client revient à la connexion avec un message, puis à la page qu'il consultait. */
const surveillerSession = (api: AxiosInstance) => {
  api.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      const url = error.config?.url ?? '';
      if (error.response?.status === 401 && !ROUTES_SANS_SESSION.some(r => url.startsWith(r))) {
        terminerSessionExpiree();
      }
      return Promise.reject(error);
    },
  );
};

/* user-service : le jeton part aussi en en-tête. Les routes du compte client
   (/user/client-profile, /user/client-password) l'acceptent en Bearer comme
   en cookie ; l'en-tête ne dépend pas des réglages de cookies du navigateur. */
poserJeton(userApi);
poserJeton(locationApi);
poserJeton(adminApi);
[userApi, locationApi, adminApi].forEach(surveillerSession);
